<template>
  <div class="row" v-if="this.event.Services">
      
   <!--<div class="row" v-if="event && event.Downloads">-->
    <div class="row" v-if="this.sel_downloads">
        <div class="col-md-12">
            <div v-if="logged">

                <div class="row boxs--wrapper">
                    <div class="col-12" v-for="down in this.sel_downloads" :key="down.ID">
                    <!--//AV    <div class="col-12" v-for="down in sel_downloads" :key="down.ID">                                        -->
                        <div class="chart-doc-box--wrapper" if v-if="down.Publish">
                            <div class="chart-doc-box--wrapper--header">
                                <img class="d-none d-lg-inline-block" src="../assets/svg/chart-icon.svg"
                                        height="30" alt="">
                                <div class="chart-doc-box--wrapper--header--hgroup">
                                    <div class="chart-doc-box--wrapper--header--hgroup--eyebrow">
                                        {{$t('downloads.chart')}} {{down.Description}}
                                    </div>
                                    <div class="chart-doc-box--wrapper--header--hgroup--title">
                                        {{$t('downloads.version')}} {{down.Version}}<br>{{$t('downloads.last_update')}}
                                        {{down.FileDate|fromNow}}
                                    </div>
                                </div>
                            </div>
                            <img class="chart-doc-box--wrapper--cta"
                                    src="../assets/svg/icons/IconaPDF_Color.svg" height="80"
                                    :alt="$t('downloads.chart_pdf')"
                                    @click="downloadClassifica(down,'pdf')">
                            <img class="chart-doc-box--wrapper--cta"
                                    src="../assets/svg/icons/IconaXLS_Color.svg" height="80"
                                    :alt="$t('downloads.chart_xls')" v-if="hasExcel(down)"
                                    @click="downloadClassifica(down,'xls')">
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-center py-3 rounded mb-2" v-else>
                <img src="../assets/svg/lock-icon.svg" class="mr-3" height="20" alt="">
                <div class="mr-3">{{$t('login_for_download_chart')}}</div>
                <Login></Login>
            </div>
        </div>
    </div>        
        <!--<div v-if="gesture.show">-->
        <!--<div class="gesture-tips-chart" v-if="gesture.show">-->
        <!--<b-alert show>-->
        <!--<div>-->
        <!--<div>{{$t('gesture_tips_chart.title')}}</div>-->
        <!--<div class="mt-1" @click="gestureHide">-->
        <!--<div class="mt-1" @click="gestureHide">-->
        <!--<div class="gesture-tips-chart__cta">{{$t('gesture_tips_chart.cta')}}</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--<img class="mx-3" src="../assets/svg/swipe-icon.svg">-->
        <!--</b-alert>-->
        <!--</div>-->        
        <div class="col-12">
            <div class="p-4 rounded bg-orange">
                <div class="row">
                    <div class="col-12" v-if="opt_events.length > 1">
                        <label class="text-uppercase small text-white pl-2">{{$t('banner_filter.event')}}</label>
                        <b-form-select v-model="classifica.event" :options="opt_events"
                                       @change="updateClassifica"></b-form-select>
                    </div>
                    <div class="col-12 col-lg-12 mt-1 mt-lg-3" v-if="opt_rankings.length > 1">
                        <label class="text-uppercase small text-white pl-2">{{$t('banner_filter.rankings')}}</label>
                        <b-form-select v-model="classifica.id" :options="opt_rankings"
                                       @change="updateClassifica"></b-form-select>
                    </div>
                    <div class="col-6 col-lg-3 mt-1 mt-lg-3" v-if="splits.length > 1">
                        <label class="text-uppercase small text-white pl-2">{{$t('banner_filter.splits')}}</label>
                        <b-form-select v-model="classifica.split" :options="splits"
                                       @change="updateClassifica"></b-form-select>
                    </div>
                    <div class="col-6 col-lg-3 mt-1 mt-lg-3">
                        <label class="text-uppercase small text-white pl-2">{{$t('banner_filter.gender')}}</label>
                        <b-form-select v-model="classifica.sesso" :options="opt_sex"
                                       @change="updateClassifica"></b-form-select>
                    </div>
                    <div class="col-6 col-lg-3 mt-1 mt-lg-3">
                        <label class="text-uppercase small text-white pl-2">{{$t('banner_filter.country')}}</label>
                        <b-form-select v-model="classifica.country" :options="opt_country"
                                       @change="updateClassifica"></b-form-select>
                    </div>
                    <div class="col-6 col-lg-3 mt-1 mt-lg-3">
                        <label class="text-uppercase small text-white pl-2">{{$t('banner_filter.age_group')}}</label>
                        <b-form-select v-model="classifica.agegroup" :options="opt_agegroup"
                                       @change="updateClassifica"></b-form-select>
                    </div>
                    <div class="col-12 mt-1 mt-lg-3">
                        <label class="text-uppercase small text-white pl-2">
                            {{$t('banner_filter.free_search')}}
                            <span class="small text-white mt-1 pr-2 text-right" style="visibility: hidden;"
                                  :class="{'show-help-text': classifica.testo.length <= 2 && classifica.testo.length > 0}">
                            {{$t('search_box.help_text_min_characters')}}
                        </span>
                        </label>
                        <b-form-input v-model="classifica.testo" :placeholder="$t('placeholder_ricerca')"
                                      @input="updateTextClassifica"></b-form-input>

                    </div>
                </div>
            </div>
            <!--<BoxServizi :data="data" :atl="false" :event="event"></BoxServizi>-->
            <!--<div class="mt-4 table-race" id="gesture_div">-->
            <div class="mt-4 table-race" id="classifica_head">
                <!--<div class="shadow-race"><div class="shadow-race__content"></div></div>-->
                <div class="table-race__content">
                    <div class="table-race__head d-none d-lg-flex">
                        <div class="table-race__slot"
                             v-if="ranking.Rank">
                            <div>{{$t('charts_head.position')}}</div>
                        </div>
                        <div class="table-race__slot fixed-width d-inline-block d-lg-none"
                             v-if="ranking.Name">
                            <div>
                                <div>
                                    <div>{{$t('charts_head.name_surname')}}</div>
                                    <div class="d-block font-italic small" v-if="ranking.ClubName">
                                        {{$t('charts_head.team')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-race__slot d-inline-block d-lg-none"
                             v-if="ranking.Result_1 && label_res_1">
                            <div>{{label_res_1}}</div>
                        </div>
                        <div class="table-race__slot"
                             v-if="ranking.RankMW">
                            <div>{{$t('charts_head.position_sm')}}</div>
                        </div>
                        <div class="table-race__slot"
                             v-if="ranking.RankAgeGroup">
                            <div>{{$t('charts_head.position_cat')}}</div>
                        </div>
                        <div class="table-race__slot"
                             v-if="ranking.BibString">
                            <div>{{$t('charts_head.bib_number')}}</div>
                        </div>
                        <div class="table-race__slot fixed-width d-none d-lg-inline-block"
                             v-if="ranking.Name">
                            <div>
                                <div>
                                    <div><b>{{$t('charts_head.name_surname')}}</b></div>
                                    <div class="d-block font-italic small" v-if="ranking.ClubName">
                                        {{$t('charts_head.team')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-race__slot"
                             v-if="!ranking.Name && ranking.ClubName">
                            <div>{{$t('charts_head.team')}}</div>
                        </div>
                        <div class="table-race__slot"
                             v-if="ranking.Country">
                            <div>{{$t('charts_head.country')}}</div>
                        </div>
                        <div class="table-race__slot"
                             v-if="ranking.AgeGroup">
                            <div>{{$t('charts_head.age_group')}}</div>
                        </div>
                        <div class="table-race__slot"
                             v-if="ranking.ResultCount">
                            <div>{{$t('charts_head.total')}}</div>
                        </div>
                        <div class="table-race__slot d-none d-lg-inline-block"
                             v-if="ranking.Result_1 > 0 && label_res_1">
                            <div><b>{{label_res_1}}</b></div>
                        </div>
                        <div class="table-race__slot"
                             v-if="ranking.Result_2 && label_res_2">
                            <div>{{label_res_2}}</div>
                        </div>
                        <div class="table-race__slot"
                             v-if="isActiveAndInThePast(event.Services.Photo)">
                            <div>{{$t('charts_head.foto')}}</div>
                        </div>
                    </div>
                    <div class="table-race__body" v-for="atl in classifica.data" :key="atl.ID" @click="infoAtleta(atl)">
                        <div v-if="ranking.Rank" class="table-race__slot d-none d-lg-inline-block">
                            <!--<div :class="{'rank_no mx-auto':atl.Result.Rank}" v-if="ranking.Rank">{{atl.Result.Rank}}</div>-->
                            <div>
                                <div :class="{'is-null':!atl.Result.Rank}" class="rank_no mr-2">{{atl.Result.Rank}}
                                </div>
                            </div>
                        </div>
                        <div class="table-race__slot fixed-width d-inline-block d-lg-none text-left">
                            <div class="w-100">
                                <div class="w-100" :class="{'cursor-pointer': splits.length > 1}">
                                    <div class="pb-2 px-2 d-flex align-items-start justify-content-start">
                                        <div v-if="ranking.Rank">
                                            <div :class="{'is-null':!atl.Result.Rank}" class="rank_no mr-2">
                                                {{atl.Result.Rank}}
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-between w-100">
                                            <div class="pr-3">
                                                <div class="font-weight-bold font-family-sans-serif mb-0"
                                                     style="letter-spacing: .43px; white-space: normal;line-height: 1"
                                                     v-if="ranking.Name">{{atl.Surname}} {{atl.Name}}
                                                </div>
                                                <div class="font-italic small" style="white-space: initial;"
                                                     v-if="ranking.ClubName && ranking.Name">{{atl.ClubName}}
                                                </div>
                                                <div class="font-weight-bold font-family-sans-serif"
                                                     style="white-space: initial;"
                                                     v-if="ranking.ClubName && !ranking.Name">{{atl.ClubName}}
                                                </div>
                                            </div>
                                            <div>
                                                <div v-if="ranking.BibString">
                                                    <div class="bib-string small"><span
                                                            class="d-inline-block d-lg-none">#</span>{{atl.BibString}}
                                                    </div>
                                                </div>
                                                <div class="country-flag" v-if="ranking.Country">
                                                    <img :src="`${publicPath}flags/${atl.Country}.gif`"
                                                         :alt="atl.Country" v-if="atl.Country"
                                                         v-b-tooltip.hover :title="atl.Country">
                                                </div>
                                            </div>
                                        </div>
                                        <!--<div class="more-detail d-none d-lg-inline-block"><img src="../assets/svg/more-icon.svg"></div>-->
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between pt-0 pr-2 timingMobile"
                                         :class="{'hasRanking':ranking.Rank}">
                                        <div v-if="ranking.Result_1 && label_res_1" class="font-family-sans-serif m-0">
                                            <div v-if="atl.Result.Note" v-b-tooltip="atl.Result.Note"
                                                 class="text-center">
                                                <div class="d-flex align-items-center">
                                                    <img class="mr-1" src="../assets/svg/alert-icon.svg" height="14"
                                                         alt="">
                                                    <div class="text-uppercase small">{{label_res_1}}
                                                        {{atl.Result.Result_1}}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center" v-else>
                                                <div class="text-uppercase small">{{label_res_1}}
                                                    {{atl.Result.Result_1}}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="ranking.ResultCount">
                                            <div>{{$t('charts_head.total')}} {{atl.Result.ResultCount}}</div>
                                        </div>
                                        <div style="align-self: flex-end">
                                            <div v-if="(isActiveAndInThePast(event.Services.Certificate) || isAvailable(event.Services.Certificate))"
                                                 class="d-inline-block mr-2">
                                                <div class="bg-white border border-secondary rounded d-inline-block p-2"
                                                     style="line-height: normal">
                                                    <a target="_blank" @click="downloadCertificate(atl)">
                                                        <img src="../assets/svg/certified.svg" width="20" height="20"
                                                             alt="">
                                                    </a>
                                                </div>
                                            </div>
                                            <div v-if="isActiveAndInThePast(event.Services.Photo)"
                                                 class="d-inline-block mr-2">
                                                <div class="bg-primary rounded d-inline-block p-2"
                                                     style="line-height: normal">
                                                    <a :href="urlFoto(atl)"
                                                       @click="track('navigation','photo',data.TrackingCategory,event.Name)"
                                                       target="_blank">
                                                        <img src="../assets/svg/icon-camera.svg" width="20" height="20"
                                                             alt="">
                                                    </a>
                                                </div>
                                            </div>
                                            <div v-if="hasDetail" class="d-inline-block">
                                                <div class="text-dark bg-orange p-2 rounded">
                                                    <img src="../assets/svg/icon-arrow-right-light-no-outline.svg"
                                                         width="20" height="20" alt="">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-race__slot d-none d-lg-inline-block" v-if="ranking.RankMW">
                            <div>{{atl.Result.RankMW}}</div>
                        </div>
                        <div class="table-race__slot d-none d-lg-inline-block"
                             v-if="ranking.RankAgeGroup">
                            <div>{{atl.Result.RankAgeGroup}}</div>
                        </div>
                        <div class="table-race__slot d-none d-lg-inline-block" v-if="ranking.BibString">
                            <div class="bib-string small">{{atl.BibString}}</div>
                        </div>
                        <div class="table-race__slot fixed-width d-none d-lg-inline-block" v-if="ranking.Name">
                            <div>
                                <div :class="{'cursor-pointer': splits.length > 1}">
                                    <div>
                                        <div>
                                            <div class="font-weight-bold">{{atl.Surname}} {{atl.Name}}</div>
                                            <div class="font-italic small" v-if="ranking.ClubName">{{atl.ClubName}}
                                            </div>
                                        </div>
                                        <!--<div class="more-detail d-none d-lg-inline-block"><img src="../assets/svg/more-icon.svg"></div>-->
                                        <div class="" v-if="hasDetail">
                                            <div class="text-dark">
                                                <span>{{$t('details')}}</span>
                                                <img height="6" class="ml-1"
                                                     src="../assets/svg/ext-link-arrow-dark.svg">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-race__slot d-none d-lg-inline-block" v-if="!ranking.Name && ranking.ClubName">
                            <div class="font-weight-bold">{{atl.ClubName}}</div>
                            <div class="d-block" v-if="hasDetail">
                                <div class="text-dark">
                                    <span>{{$t('details')}}</span>
                                    <img height="6" class="ml-1" src="../assets/svg/ext-link-arrow-dark.svg">
                                </div>
                            </div>
                        </div>
                        <div class="table-race__slot d-none d-lg-inline-block" v-if="ranking.Country">
                            <div class="country-flag">
                                <img :src="`${publicPath}flags/${atl.Country}.gif`" :alt="atl.Country"
                                     v-if="atl.Country"
                                     v-b-tooltip.hover :title="atl.Country">
                            </div>
                        </div>
                        <div class="table-race__slot d-none d-lg-inline-block" v-if="ranking.AgeGroup">
                            <div>{{atl.AgeGroup}}</div>
                        </div>
                        <div class="table-race__slot d-none d-lg-inline-block" v-if="ranking.ResultCount">
                            <div>{{atl.Result.ResultCount}}</div>
                        </div>
                        <div class="table-race__slot d-none d-lg-inline-block"
                             v-if="ranking.Result_1 && label_res_1">
                            <div v-if="atl.Result.Note" v-b-tooltip="atl.Result.Note" class="text-center">
                                <div><img class="mb-1" src="../assets/svg/alert-icon.svg" height="20" alt=""><br><b>{{atl.Result.Result_1}}</b>
                                </div>
                            </div>
                            <div v-else><b>{{atl.Result.Result_1}}</b></div>
                        </div>
                        <div class="table-race__slot d-none d-lg-inline-block"
                             v-if="ranking.Result_2 && label_res_2">
                            <div v-if="atl.Result.Note" v-b-tooltip="atl.Result.Note" class="text-center">
                                <div><img class="mb-1" src="../assets/svg/alert-icon.svg" height="20" alt=""><br>{{atl.Result.Result_2}}
                                </div>
                            </div>
                            <div v-else>{{atl.Result.Result_2}}</div>
                        </div>
                        <div class="table-race__slot d-none d-lg-inline-block"
                             v-if="isActiveAndInThePast(event.Services.Photo)">
                            <div>
                                <a class="bg-primary py-2 px-3 rounded text-white text-center text-uppercase rounded d-flex align-items-center justify-content-center"
                                   :href="urlFoto(atl)"
                                   @click="track('navigation','photo',data.TrackingCategory,event.Name)"
                                   target="_blank">{{$t('charts_head.foto')}} <img class="ml-1"
                                                                                   src="../assets/svg/ext-link-arrow-light.svg"
                                                                                   height="6" alt=""></a></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column">
                <div class="text-right pt-2 text-muted float-lg-right">
                    <!--{{classifica.data.length}} {{$t('of')}} -->
                    {{classifica.tot}} {{$t('charts.total_subscribers')}}
                </div>
                <div v-if="logged" class="d-flex justify-content-center d-lg-inline-block">
                    <div v-if="(classifica.tot > classifica.numPerPage)"
                         class="d-lg-flex align-items-center justify-content-between py-3">
                        <div class="small text-uppercase text-center text-muted float-lg-left align-baseline d-flex">
                            <div class="d-inline-block mr-2">
                                <b-form-select v-model="classifica.numPerPage" :options="numPerPages"
                                               @change="updateClassifica"></b-form-select>
                                <div class="px-3 small mt-1">Righe per pagina</div>
                            </div>
                            <div class="d-inline-block">
                                <div class="button-container">
                                    <b-input @keydown.enter.native="changePage" class=" text-center px-0 input-custom"
                                             type="text" v-model.lazy="goToPage"></b-input>
                                    <div @click="changePage" class="arrow-container"><i
                                            :class="{ arrowIsActive: arrow_active_class }"
                                            class="arrow-custom right-custom"></i></div>
                                </div>

                                <div class="px-3 small mt-1">Vai a pagina</div>
                            </div>
                        </div>
                        <div class="block-pagination flex-grow-1 justify-content-start justify-content-md-center">
                            <b-pagination style="padding-bottom: 15px;"
                                          :total-rows=Number(classifica.tot)
                                          v-model="classifica.pag"
                                          :per-page="classifica.numPerPage"
                                          limit="4"
                                          @change="getClassifica"></b-pagination>
                        </div>
                        <!--<div class="text-center text-muted float-lg-right">-->
                        <!--&lt;!&ndash;{{classifica.data.length}} {{$t('of')}} &ndash;&gt;-->
                        <!--{{classifica.tot}} {{$t('charts.total_subscribers')}}-->
                        <!--</div>-->
                    </div>
                </div>
            </div>

            <!--Login-->
            <!--//AV: <div class="row" v-if="event && event.Downloads">-->
            <div class="row" v-if="sel_downloads">                
                <div class="col-md-12">
                    <div class="d-flex align-items-center justify-content-center py-3 rounded mb-2" v-if="!logged">
                        <img src="../assets/svg/lock-icon.svg" class="mr-3" height="20" alt="">
                        <div class="mr-3">{{$t('login_for_download_chart')}}</div>
                        <Login></Login>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-center py-3 rounded mb-2" v-else>
                <img src="../assets/svg/lock-icon.svg" class="mr-3" height="20" alt="">
                <div class="mr-3">{{$t('login_for_download_chart')}}</div>
                <Login></Login>
            </div>

            <BoxServizi :data="data" :atl="false" :event="event" :ranking="this.classifica"></BoxServizi>
        </div>
        <b-modal id="dettaglio_atleta" centered hide-footer size="xl">
            <template v-slot:modal-title>
                {{data.Description}} <span v-if="events.length > 1">: <b>{{detAtl.EventDescription}}</b></span> ({{data.RaceDate|date}})
            </template>
            <div class="dettaglio-atleta" v-if="detAtl">
                <div class="dettaglio-atleta--header">
                    <div class="w-100 d-flex flex-column">
                        <div class="w-100 d-flex justify-content-around align-items-center pb-3">
                            <div class="country-flag">
                                <img class="img-fluid" :src="`${publicPath}flags/${detAtl.Country}.gif`"
                                     :alt="detAtl.Country"
                                     v-if="detAtl.Country" v-b-tooltip.hover :title="detAtl.Country">
                            </div>
                            <div class="dettaglio-atleta--header--bib-number d-none d-sm-block">{{detAtl.BibString}}
                            </div>
                            <div class="dettaglio-atleta--header--agegroup">{{detAtl.AgeGroup}}</div>
                        </div>
                        <div class="dettaglio-atleta--header--bib-number d-block d-sm-none">{{detAtl.BibString}}</div>
                    </div>

                    <div>

                        <div class="dettaglio-atleta--header--title" v-if="detAtl.Surname && detAtl.Name">
                            {{detAtl.Surname}} {{detAtl.Name}}
                        </div>
                        <div class="dettaglio-atleta--header--subtitle"
                             v-if="detAtl.Surname && detAtl.Name && detAtl.Country">{{detAtl.ClubName}}
                        </div>
                        <div class="dettaglio-atleta--header--title"
                             v-if="!detAtl.Surname && !detAtl.Name && detAtl.Country">{{detAtl.ClubName}}
                        </div>
                    </div>

                </div>
                <div v-if="detAtl.Note"
                     class="d-inline-flex align-items-center mb-3 p-3 text-danger border-left border-danger">
                    <img class="mr-3" src="../assets/svg/alert-icon.svg" height="25" alt=""> {{detAtl.Note}}
                </div>
                <div class="d-flex align-items-center justify-content-center pt-3 pb-3 d-block d-lg-none">
                    <div class="pr-4 pl-2">
                        <img src="../assets/svg/hand-swipe.svg" alt="handSwipe" height="30">
                    </div>
                    <div>
                        <span>{{$t('athlete_details.message')}}</span>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-hover">
                        <tr>
                            <th></th>
                            <th class="text-center" v-if="rankingDetail.Distance">{{$t('athletes_details.distance')}}
                            </th>
                            <th class="text-center" v-if="rankingDetail.Rank">{{$t('athletes_details.position')}}</th>
                            <th class="text-center" v-if="rankingDetail.RankMW">{{$t('athletes_details.position_mf')}}
                            </th>
                            <th class="text-center" v-if="rankingDetail.RankAgeGroup">
                                {{$t('athletes_details.position_cat')}}
                            </th>
                            <th class="text-center" v-if="rankingDetail.Result_1">{{label_res_1}}<br>{{splitsAtl[0].um}}
                            </th>
                            <th class="text-center" v-if="rankingDetail.Result_2">{{label_res_2}}</th>
                            <th class="text-center" v-if="rankingDetail.SplitResult_1">
                                {{$t('athletes_details.partial')}}<br>{{splitsAtl[0].um}}
                            </th>
                            <!--<th class="text-center" v-if="ranking.SplitSpeedStamp">{{speedUm}}</th>-->
                        </tr>
                        <tr v-for="split in splitsAtl" :key="split.ID">
                            <td class="text-uppercase font-weight-bold text-primary">{{split.nome}}</td>
                            <td class="text-center" v-if="rankingDetail.Distance">{{split.distanza}}</td>
                            <td class="text-center" v-if="rankingDetail.Rank">
                                {{split.Rank}}
                                <span class="border-left border-secondary py-1 pl-2 mx-2 text-left"
                                      v-if="split.DeltaRank && split.DeltaRank != 0">
                                    <img height="20" :src="valutateDelta(split.DeltaRank,split.count)">
                                    {{split.DeltaRank|abs}}
                                 </span>
                            </td>
                            <td class="text-center" v-if="rankingDetail.RankMW">
                                {{split.RankMW}}
                                <span class="border-left border-secondary py-1 pl-2 mx-2 text-left"
                                      v-if="split.DeltaRankMW && split.DeltaRankMW != 0">
                                    <img height="20" :src="valutateDelta(split.DeltaRankMW,split.count)">
                                    {{split.DeltaRankMW|abs}}
                                 </span>
                            </td>
                            <td class="text-center" v-if="rankingDetail.RankAgeGroup">
                                {{split.RankAgeGroup}}
                                <span class="border-left border-secondary py-1 pl-2 mx-2 text-left"
                                      v-if="split.DeltaRankAgeGroup && split.DeltaRankAgeGroup != 0">
                                    <img height="20" :src="valutateDelta(split.DeltaRankAgeGroup,split.count)">
                                    {{split.DeltaRankAgeGroup|abs}}
                                 </span>
                            </td>
                            <td class="text-center" v-if="rankingDetail.Result_1">
                                {{split.Result_1}}
                                <span v-if="ranking.SpeedStamp" class="d-block">{{split.speed}}</span>
                            </td>
                            <td class="text-center" v-if="rankingDetail.Result_2">{{split.Result_2}}</td>
                            <td class="text-center" v-if="rankingDetail.SplitResult_1">
                                {{split.parziale}}
                                <span v-if="ranking.SplitSpeedStamp"
                                      class="d-block a">{{split.splitSpeed}}</span>
                                <span v-else class="d-block b">{{split.speed}}</span>
                            </td>
                        </tr>
                    </table>
                </div>

                <BoxServizi :data="data" :atl="detAtl" :event="event" :ranking="this.classifica"></BoxServizi>
            </div>
        </b-modal>
        <DownloadCertificate ref="cert"></DownloadCertificate>
     
</div>
</template>

<script>
    import debounce from 'lodash/debounce'
    import {EventBus} from '../util/event-bus.js'
    import BaseVue from '../views/BaseVue'
    import BoxServizi from "./BoxServizi"
    import DownloadCertificate from './DownloadCertificate'
    import Login from '../components/Login'
    import Analytics from '../util/analytics'

    export default {
        extends: BaseVue,
        name: 'Classifica',
        props: ['data', 'event1'], //av todo (va bene ?)
        components: {DownloadCertificate, BoxServizi, Login},
        data() {
            return {
                pop1: false,
                goToPage: '',
                cambioPagina: '',
                arrow_active_class: false,
                publicPath: process.env.BASE_URL,
                classifiche: [],
                sel_downloads: {},
                numPerPages: [10, 20, 30, 50],
                classifica: {
                    data: [],
                    pag: 1,
                    tot: 0,
                    numPerPage: 20,
                    event: -1,
                    sesso: -1,
                    agegroup: -1,
                    country: -1,
                    split: 0,
                    testo: '',
                    opts: {
                        agegroup: [],
                        country: [],
                        sex: []
                    },
                    md5url: '',
                    md5search: '',
                    id: 0
                },
                gesture: {
                    show: false,
                    hide: false,
                    offsetBegin: 400,
                    offsetEnd: 0
                },
                result_type: [],
                detAtl: null,
                ev_sel: null,
                oldEv: null,
            }
        },
        watch: {
            goToPage: function (value) {
                this.cambioPagina = parseInt(value)
                if (!isNaN(this.cambioPagina) && this.cambioPagina !== this.classifica.pag) {
                    this.arrow_active_class = true
                    this.classifica.pag = this.cambioPagina
                }
                // else {
                //     console.log('else')
                //     this.arrow_active_class = false
                // }
            },
            'classifica.pag': function () {
                this.goToPage = this.classifica.pag
            }
        },
        computed: {
            isPica() {
                if (!this.data || !this.data.Services)
                    return false
                return (this.data.Services.PhotoUrl === 'https://www.getpica.com')
            },
            event() {
                if  (this.events.length <= 0) return {}
                for (let i = 0; i < this.events.length; i++)
                    if (this.events[i].ID === this.classifica.event) {
                        let ev = this.events[i]
                        if (this.old_ev !== ev.ID) {
                            // eslint-disable-next-line
                            this.old_ev = ev.ID
                            // eslint-disable-next-line
                            this.classifica.split = null
                            for (let i = 0; i < ev.RaceSplits.length; i++) {
                                if (!ev.RaceSplits[i].Enabled)
                                    continue

                                if (ev.RaceSplits[i].IsDefault) {
                                    // eslint-disable-next-line
                                    this.classifica.split = ev.RaceSplits[i].ID
                                    break
                                }
                                if (this.classifica.split === null) {
                                    // eslint-disable-next-line
                                    this.classifica.split = ev.RaceSplits[i].ID
                                }

                            }
                            // eslint-disable-next-line
                            if (this.classifica.split === null) this.classifica.split = 0

                            // eslint-disable-next-line
                            EventBus.$emit('event_changed', true)
                        }
                        return ev
                    }
                return {}
            },
            opt_events() {
                let opts = []
                for (let i = 0; i < this.events.length; i++)
                    opts.push({value: this.events[i].ID, text: this.events[i].Name})
                return opts
            }, 
            opt_rankings() {
                let opts = []
                for (let i = 0; i < this.classifiche.length; i++)
                    opts.push({value: this.classifiche[i].Code, text: this.classifiche[i].Description})
                return opts
            }, 
            opt_sex() {
                let opts = this.optsFromValue(this.classifica.opts.sex, this.$t('default.sex'))
                for (let i = 0; i < opts.length; i++) {
                    let opt = opts[i]
                    if ((opt.value === 'M') || (opt.value === 'F')) {
                        opt.text = this.$t('sesso.' + opt.value) + opt.text.substr(1) // this.$t.translate('')
                    }
                }
                return opts
            }, 
            opt_agegroup() {
                return this.optsFromValue(this.classifica.opts.agegroup, this.$t('default.agegroup'))
            }, 
            opt_country() {
                return this.optsFromValue(this.classifica.opts.country, this.$t('default.country'))
            }, 
            ranking() {
                if (this.classifiche.length <= 0)
                    return {}
                for (let i = 0; i < this.classifiche.length; i++) {
                    let rank = this.classifiche[i]
                    if (rank.Code == this.classifica.id) {
                        // Verifico quale è la classifica attiva
                        this.sel_downloads = rank.Downloads
                        let fields = rank.FieldList.split(',')
                        for (let j = 0; j < fields.length; j++)
                            if (fields[j] === 'Description')
                                rank['Description_field'] = 1
                            else
                                rank[fields[j]] = 1
                        return rank
                    }

                }
                return {}
            }, 
            rankingDetail() {
                if (this.classifiche.length <= 0)
                    return false
                for (let i = 0; i < this.classifiche.length; i++) {
                    let rank = this.classifiche[i]
                    if (rank.Code == this.classifica.id) {
                        // Verifico quale è la classifica attiva
                        if (rank.DetailsFieldList === '') return false
                        let fields = rank.DetailsFieldList.split(',')
                        let fieldArr = {}
                        for (let j = 0; j < fields.length; j++)
                            if (fields[j] === 'Description')
                                fieldArr['Description_field'] = 1
                            else
                                fieldArr[fields[j]] = 1
                        if (fieldArr === {}) return false
                        return fieldArr
                    }

                }
                return {}
            }, 
            hasDetail() {
                if (!this.event) return false
                if (this.rankingDetail === false) return false
                return true
                // if (this.isPica) return true
                // if (this.isActiveAndInThePast(this.event.Services.Video)) return true
                // if (this.isActiveAndInThePast(this.event.Services.Certificate)) return true
                //
                // // Se sono admin e ci sono i certificati, allora lo abilito
                // if (this.admin && this.isAvailable(this.event.Services.Certificate)) return true
                //
                // if (this.splits.length <= 1) return false
                // if (!this.ranking.Name) return false
                // return true
            },
            events() {
                let events = []
                for (let i = 0; i < this.data.Events.length; i++) {
                    if (this.isEnabled(this.data.Events[i].Result) && (this.data.Events[i].Enabled))
                        events.push(this.data.Events[i])
                    else if (this.admin)
                        events.push(this.data.Events[i])
                }
                return events
            }, 
            splits() {
                if (this.classifica.event <= 0) return []

                let splits = []
                if (!this.event) return []

                let rsplit = this.raceSplits

                for (let i = 0; i < rsplit.length; i++)
                    if (rsplit[i])
                        splits.push({value: rsplit[i].ID, text: rsplit[i].Description})
                return splits
            }, 
            raceSplits() {
                if (this.classifica.event <= 0) return []

                let splits = []
                if (!this.event) return []

                let rsplit = this.event.RaceSplits

                if (rsplit === null) return []

                for (let i = 0; i < rsplit.length; i++)
                    if (rsplit[i] && rsplit[i].Enabled)
                        splits.push(rsplit[i])
                return splits
            },
            splitsAtl() {
                if (!this.detAtl)
                    return []

                let data = []

                let splits = this.event.RaceSplits
                let rsplit = []
                for (let i = 0; i < splits.length; i++)
                    if (splits[i] && splits[i].DetailsEnabled)
                        rsplit.push(splits[i])

                for (let i = 0; i < rsplit.length; i++) {
                    // Cerco i risultati dell'atleta
                    let split = null
                    for (let j = 0; j < this.detAtl.Splits.length; j++) {
                        if (this.detAtl.Splits[j].ID === rsplit[i].ID)
                            split = this.detAtl.Splits[j]
                    }
                    if (split !== null) {
                        split.parziale = split.Result_1.split(';')[0]
                        split.speed = split.SpeedStamp.split(';')[0]
                        split.splitSpeed = split.SplitSpeedStamp.split(';')[0]
                        split.parziale = split.SplitResult_1.split(';')[0]
                        split.um = split.SpeedStamp.split(';')[1]
                        split.nome = rsplit[i].Description
                        split.count = rsplit[i].ResultsCount
                        split.distanza = rsplit[i].Distance
                        data.push(split)
                    }
                }

                return data
            }, 
            speedUm() {
                if (!this.detAtl) return ''
                let speed = this.detAtl.Splits[0].SpeedStamp
                return speed.split(';')[1]
            }, 
            label_res_1() {
                if (!this.ranking) return ''
                return this.result_label(this.ranking.Result_1ID)
            }, 
            label_res_2() {
                if (!this.ranking) return ''
                return this.result_label(this.ranking.Result_2ID)
            }
        }, 
        created() {
            this.goToPage = this.classifica.pag
        },
        mounted() {
            EventBus.$on('login', () => {
                // Resetto lo stato dell'md5 search, altrimenti vede che è uguale
                // e pensa che non cambi nulla visto che il token è 'a parte' e non si accorge di quel cambiamento
                this.classifica.md5search = ''
                this.updateClassifica()
            })
            EventBus.$on('logout', () => {
                this.updateClassifica()
            })
            EventBus.$on('classifica', () => {
                for (let i = 0; i < this.data.Events.length; i++) {
                    if (!this.isEnabled(this.data.Events[i].Result) || (!this.data.Events[i].Enabled))
                        continue


                    let ev = this.data.Events[i]
                    this.classifica.event = ev.ID
                    for (let j = 0; j < ev.RaceSplits.length; j++) {
                        if (ev.RaceSplits[j].IsDefault) {
                            this.classifica.split = ev.RaceSplits[j].ID
                            break
                        }
                    }
                    if (this.data.Events[i].IsDefault)
                        break

                }

                if (this.classifica.id)
                    this.updateClassifica()
            })
            EventBus.$on('event_changed', () => {
                this.getRankings()
            })
            EventBus.$on('ranking_changed', () => {
                this.updateClassifica()
            })
            this.getResultType()

            // if (localStorage.getItem('gesture_hidden'))
            //     this.gesture.hide = true
            // else
            //     window.addEventListener('scroll',this.gestureScroll)
            }, methods: {
            async downloadCertificate(atl) {
                this.$refs.cert.download(this.data, this.event, atl, this.classifica.id)
            }, async downloadClassifica(down,type) {
                Analytics.track('file_download','ranking',this.data.TrackingCategory,this.event.Name)
                //questa prima parte gestisce le vecchie class che non sono più usata in realtà...(apache è stato spento)
                if (down.LinkUri.indexOf('file://') === 0) {
                    // "file:///usr/local/cron/classificheGenerator/classifiche/2019_10420_1_07007_Corsa_de_Noantri-Generale_Risultati_ufficiosi"
                    this.downloadClassForm.action = 'https://api.tds.sport/ns/servlet/pdfDownload'
                    this.downloadClassForm.filename = down.LinkUri.substr(7)
                    await this.$nextTick()
                    this.$refs.downloadClass.submit()
                } else {
                    let url = down.LinkUri +'/'+type
                    window.open(url, '_blank')
                }
            }, hasExcel(down)
            {
                if (down.LinkUri.indexOf('file://') === 0)
                    return false
                return  true
            }, gestureHide() {
                this.gesture.show = false
                this.gesture.hide = true
                localStorage.setItem('gesture_hidden', 'true')
                window.removeEventListener('scroll', this.gestureScroll)
            }, gestureScroll() {
                if (!this.gesture.div)
                    this.gesture.div = document.getElementById('gesture_div')

                let supportPageOffset = window.pageYOffset !== undefined
                let isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat')
                // Verifico di quanto siamo scrollati verticalmente
                let scroll_position = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop

                let ret = this.gesture.div.getBoundingClientRect()
                let begin = ret.top + this.gesture.offsetBegin + scroll_position
                let end = ret.bottom + this.gesture.offsetEnd + scroll_position

                scroll_position += window.innerHeight

                this.gesture.show = scroll_position > begin && scroll_position < end
            },
            urlFoto(atl) {
                let path = this.data.Services.PhotoUrl
                let replaces = Object.keys(atl)
                for (let i = 0; i < replaces.length; i++)
                    path = path.replace('[' + replaces[i] + ']', encodeURIComponent(atl[replaces[i]]))
                return path
            },
            //
            async updateClassifica() {
                await this.$nextTick()
                this.classifica.pag = 1
                this.getClassifica(this.classifica.pag)
            }, updateTextClassifica: debounce(function () {
                this.updateClassifica()
            }, 1000), async getClassifica(pag) {
                await this.$nextTick()
                // http://svc.tds-live.com/rest/jrest.svc/0-TDS-Anonymous-TDS-0/it/10627/results/1/0/0/10
                let url = this.data.ID + '/ranking/' + encodeURIComponent(this.classifica.id) + '/' + encodeURIComponent(this.classifica.event)

                if (this.classifica.testo.length > 2) url += '/filter/' + encodeURIComponent(this.classifica.testo)

                if (this.classifica.sesso !== -1) url += '/s/' + encodeURIComponent(this.classifica.sesso)
                if (this.classifica.agegroup !== -1) url += '/a/' + encodeURIComponent(this.classifica.agegroup)
                if (this.classifica.country !== -1) url += '/c/' + encodeURIComponent(this.classifica.country)

                url += '/' + this.classifica.split // Punto di controllo, es: Arrivo
                url += '/' + ((pag - 1) * this.classifica.numPerPage + 1) + '/' + this.classifica.numPerPage // Paginazione

                if (this.classifica.md5search === url) return
                this.classifica.md5search = url

                let result = await this.get(url, true)

                this.classifica.data = result.Results
                this.classifica.tot = result.Status.RecordCount


                this.$forceUpdate()
                this.$scrollTo(document.getElementById('classifica_head'))

                let md5url = this.makeUrl(this.classifica.sesso, this.classifica.agegroup, this.classifica.country)
                // Se non è cambiato nulla come parametri, non rieffettuo la ricerca dei valori

                if (md5url === this.classifica.md5url) return

                this.classifica.md5url = md5url

                // Faccio il fetch dei valori di agegroup,country e sex
                let data = await this.get([
                    this.makeUrl(this.classifica.sesso, -1, this.classifica.country) + '/@agegroup',
                    this.makeUrl(this.classifica.sesso, this.classifica.agegroup, -1) + '/@country',
                    this.makeUrl(-1, this.classifica.agegroup, this.classifica.country) + '/@sex',
                ])

                // Li salvo nei data, da cui verranno poi presi e rielaborati per generare i computed
                this.classifica.opts.agegroup = data[0].ValuesCounters
                this.classifica.opts.country = data[1].ValuesCounters
                this.classifica.opts.sex = data[2].ValuesCounters


            }, makeUrl(sesso, agegroup, country) {
                let url = this.data.ID + '/' + encodeURIComponent(this.classifica.event)
                url += '/r/' + this.classifica.id
                url += '/s/' + encodeURIComponent(this.classifica.split) + '/list' // Punto di controllo, es: Arrivo
                if (sesso !== -1) url += '/s/' + encodeURIComponent(sesso)
                if (agegroup !== -1) url += '/a/' + encodeURIComponent(agegroup)
                if (country !== -1) url += ''

                return url
            }, optsFromValue(values, empty) {
                if (empty === undefined) empty = ' - '

                if (values.length <= 0) return [{value: -1, text: ' - '}]
                let opts = []
                opts.push({value: -1, text: empty})
                for (let i = 0; i < values.length; i++)
                    opts.push({
                        value: values[i].Description,
                        text: values[i].Description + ' (' + values[i].Count + ')'
                    })
                return opts
            }, async infoAtleta(atl) {
                if (!this.hasDetail) return false

                this.track('navigation', 'details', this.data.TrackingCategory, this.event.Name)
                let dettaglio = await this.get(this.data.ID + '/athlete/r/' + this.classifica.id + '/' + atl.BibNumber)
                this.detAtl = dettaglio.Athletes[0]
                this.detAtl.Note = atl.Result.Note
                this.$bvModal.show('dettaglio_atleta')
            }, async getResultType() {
                let data = await this.get('table/result')
                this.result_type = data.GenericTables
            }, result_label(id) {
                id += '' // Casting a stringa per il confronto seguente

                for (let i = 0; i < this.result_type.length; i++) {
                    let type = this.result_type[i]
                    if (type.Code === id)
                        return type.Description
                }
                return ''
            }, async getRankings() {
                let data = await this.get(this.data.ID + '/rankings/' + this.event.ID)
                this.classifiche = data.Rankings
                // Setto la classifica di default
                if (this.classifiche.length > 0)
                    this.classifica.id = this.classifiche[0].Code
                EventBus.$emit('ranking_changed', true)

            }, valutateDelta(delta, tot) {
                delta = delta * 1.0
                let percent = delta / tot
                let path = 'plus_'
                if (percent < 0)
                    path = 'minus_'
                let abs = Math.abs(percent)
                if (abs < 0.01) return process.env.BASE_URL + 'delta/equals.svg'
                if (abs < 0.05) path += 'small'
                else if (abs < 0.1) path += 'medium'
                else path += 'big'
                return process.env.BASE_URL + 'delta/' + path + '.svg'
            },

            popClose() {
                this.pop1 = false
                this.getClassifica()
            },

            changePage() {
                const pagTot = Math.ceil((this.classifica.tot / this.classifica.numPerPage))
                if (this.cambioPagina > pagTot) {
                    this.goToPage = pagTot
                    this.classifica.pag = pagTot
                    this.arrow_active_class = false
                    this.getClassifica(this.classifica.pag)
                } else {
                    this.classifica.pag = this.cambioPagina
                    this.arrow_active_class = false
                    this.getClassifica(this.classifica.pag)
                }

            },

            titoloModale() {
                //console.log(this.data.Description + ':' + detAtl.EventDescriptio)
                return this.data.Description + ':' + detAtl.EventDescription
            },
        }
    }
</script>

<style scoped>

</style>
